import { formatISODate } from 'utils/dates'

type ChatBubbleProps = {
  variant: 'user' | 'bot'
  timestamp: string
  children: React.ReactNode
}

export const ChatBubble = ({ variant, timestamp, children }: ChatBubbleProps) => {
  const isUser = variant === 'user'

  return (
    <div
      className={`tw-break-words tw-px-[10px] tw-py-[6px] tw-text-sm animate-fade-slide-in ${
        isUser
          ? 'tw-rounded-tl-[12px] tw-rounded-tr-[12px] tw-rounded-bl-[12px] tw-rounded-br-[0px]'
          : 'tw-rounded-tl-[12px] tw-rounded-tr-[12px] tw-rounded-br-[12px] tw-rounded-bl-[0px]'
      }`}
      style={
        isUser
          ? {
              background: 'linear-gradient(167deg, var(--primary-gradient-start), var(--primary-gradient-end))',
              color: 'white',
            }
          : {
              backgroundColor: 'var(--bot-msg-bg)',
              color: 'var(--bot-msg-text)',
            }
      }
      dir="auto"
    >
      {children}
      <div className={`tw-mt-1 ${isUser ? 'tw-text-right' : 'tw-text-left'}`}>
        <span className="tw-text-xs tw-opacity-90" style={{ color: isUser ? 'white' : 'var(--text-muted)' }}>
          {formatISODate(timestamp)}
        </span>
      </div>
    </div>
  )
}
